import React from 'react';
import { useNavigate } from 'react-router-dom';

import GiftForm from '@/pages/gift-management/components/GiftForm';
import { useTranslation } from '@/config/i18n';
import PATH from '@/routes/path';

const GiftManagementNewPage: React.FC = () => {
  const [t] = useTranslation('');
  const navigate = useNavigate();

  return (
    <>
      <div className="header-top">
        <h2 className="title flex">
          <span
            className="pi pi-arrow-left text-[20px] text-gray-500 cursor-pointer"
            onClick={() => navigate(PATH.gift)}
          ></span>
          <span className="ml-3">{t('gift.add_new')}</span>
        </h2>
      </div>
      <GiftForm />
    </>
  );
};

export default GiftManagementNewPage;
